import BinarySelector from "./components/BinarySelector.svelte";
import ImageSelector from "./components/ImageSelector.svelte";
import Input from "./components/Input.svelte";
import Label from "./components/Label.svelte";
import Image from "./components/Image.svelte";
import {dateFormatter} from "./dateFormatter";
import Dropdown from "./components/Dropdown.svelte";
import {loadModelMetadata} from "./modelUtils";
import {customFetch} from "./customFetch";
import {notifications} from "./notifications";
import TableButton from "./components/TableButton.svelte";
import DropdownArray from "./components/DropdownArray.svelte";

export function valueView(type, step, min, max) {
    return function (row, col) {
        let props = {
            type: type,
            value: row[col],
            class: "text-input"
        }
        if (step != null) {
            props.step = step
        }
        if (min != null) {
            props.min = min
        }
        if (max != null) {
            props.max = max
        }
        return {
            component: Input,
            props: props,
        }
    }
}

export function dateView(row, col) {
    return {
        component: Label,
        props: {
            text: dateFormatter.format(row[col]),
        }
    }
}

export function labelView(row, col) {
    return {
        component: Label,
        props: {
            text:row[col],
        }
    }
}


export function buttonView(buttonName, onClickHandler) {
    return (row, col) => {
        return {
            component: TableButton,
            props: {
                buttonName: buttonName,
                onClickHandler: () => onClickHandler(row, col)
            }
        };
    };
}

export function binaryView(format, existingField) {
    return (row, col) => {
        return {
            component: BinarySelector,
            props: {
                existingId: row[existingField]?.ID,
                existingFilename: row[existingField]?.Filename,
                prefix: format,
                fileMask: "application/octet-stream",
                value: row[col],
            },
        }
    }
}

export function editableImageView() {
    return (row, col) => {
        return {
            component: ImageSelector,
            props: {
                existingId: row.IconData?.ID,
                existingFilename: row.IconData?.Filename,
                value: row.NewIcon,
            },
        }
    }
}

export function editableBigIconView(bigIconDataField = 'BigIconData', newBigIconField = 'NewBigIcon') {
    return (row, col) => {
        const bigIconData = row[bigIconDataField] || { ID: undefined, Filename: undefined };
        const newBigIcon = row[newBigIconField];

        return {
            component: ImageSelector,
            props: {
                existingId: bigIconData.ID,
                existingFilename: bigIconData.Filename,
                value: newBigIcon,
            },
        }
    }
}

export function dropdownView(items) {
    return (row, col) => {
        return {
            component: Dropdown,
            props: {
                value: row[col],
                items: items,
            }
        }
    }
}

export function dropdownArrayView(items) {
    return (row, col) => {
        return {
            component: DropdownArray,
            props: {
                values: row[col] || [],
                items: items,
            }
        }
    }
}

export function imageView(row, col) {
    return {
        component: Image,
        props: {
            value: row[col],
        }
    }
}

export async function saveRows(rows, fields, url) {
    let result = [];
    let formData = new FormData();
    let saveIfPresent = ["SoundDataId", "LevelDataId", "ModelDataId", "IconDataId", "BigIconDataId", "PortraitDataId", "DisabledPortraitDataId"];
    for (let i = 0; i < rows.length; i++) {
        let row = rows[i];

        if (row.Action === "CREATE" || row.Action === "DELETE" || row.Action === "UPDATE") {
            let item = {
                ID: rows[i].ID,
                ModelDataId: rows[i].ModelDataId,
                IconDataId: rows[i].IconDataId,
                BigIconDataId: rows[i].BigIconDataId,
                PortraitDataId: rows[i].PortraitDataId,
                DisabledPortraitDataId: rows[i].DisabledPortraitDataId,
                Action: rows[i].Action,
            };
            for (let j = 0; j < fields.length; j++) {
                let field = fields[j];
                item[field] = rows[i][field];
            }
            // saving binary data ids
            for (let j = 0; j < saveIfPresent.length; j++) {
                let field = saveIfPresent[j];
                if (rows[i][field]) {
                    item[field] = rows[i][field];
                }
            }

            result.push(item);
            let index = result.length - 1;
            if (row.NewIcon){
                formData.set("icon_data_" + index, row.NewIcon);
            }
            if (row.NewBigIcon){
                formData.set("big_icon_data_" + index, row.NewBigIcon);
            }
            if (row.NewModel) {
                formData.set("model_data_" + index, row.NewModel);
                formData.set("model_metadata_" + index, JSON.stringify(await loadModelMetadata(row.NewModel)));
            }
            if (row.NewLevel) {
                formData.set("level_data_" + index, row.NewLevel);
            }
            if (row.NewSound) {
                formData.set("sound_data_" + index, row.NewSound);
            }
            if (row.NewPortrait) {
                formData.set("portrait_data_" + index, row.NewPortrait);
            }
            if (row.NewDisabledPortrait) {
                formData.set("disabled_portrait_data_" + index, row.NewDisabledPortrait);
            }
        }

    }
    formData.set("rows", JSON.stringify(result));

    try {
        await customFetch(url, {
            method: "POST",
            body: formData,
        });
        notifications.info("Successfully saved");
    } catch (e) {
        notifications.danger(`Can't save rows: ${e.message}`);
    }
}